import React, {useEffect, useRef, useState} from 'react';
import withHeader from "../../../hocs/withHeader";
import SurveysService from "../../../../services/SurveysService";
import ConfigurationService from "../../../../services/ConfigurationService";
import GeneralStatsComponent from "../../charts/components/GeneralStatsComponent";
import ChartReportBoxComponent from "../../charts/components/ChartReportBoxComponent";
import SurveyExportButtons from './SurveyExportButtons';
import ErrorBoundary from "../../../meta/ErrorBoundary";
import {createChartsPayloadPromise} from "../../../../utils/SurveyUtils";
import ClearResponsesModal from "../../modals/ClearResponsesModal";

function SurveyReportPage(props){
    const divParentRef = useRef(null);
    const questionTypes = ["singleChoice", "multipleChoice", "text", "selects", "number", "multipleOpen"];
    const isMobile = window.innerWidth < 768;

    const [reportState, setReportState] = useState({ questionCharts: [], multipleQuestions: undefined });
    const [surveyName, setSurveyName] = useState('');
    const [generalStats,setGeneralStats] = useState('');
    const [showClearResponsesModal, setShowClearResponsesModal] = useState(false);
    const [responsesAreBeingDeleted, setResponsesAreBeingDeleted] = useState(false);

    const [questionsInfoState, setQuestionsInfoState] = useState({ questionChartsInfo: [], questionsReady: false });
    const questionChartsInfoRef = useRef(questionsInfoState.questionChartsInfo);
    const numChartsRef = useState(0);

    useEffect(()=>{
        ConfigurationService.getConfigurationByLangId("DK_NA", -1, (success) => {
            window.dknaLabel = success.data.value;
        }, (error) => {
            console.log(error);
        });

        SurveysService.getSurveyById(props.match.params.surveyId, (success) => {
            setSurveyName(success.data.title);
            buildCharts(success.data.questions);
        }, (error) =>{
            console.log(error);
        });

        SurveysService.getGeneralStats(props.match.params.surveyId, (success) =>{
            const formattedGeneralStats = getFormattedGeneralStats(success.data);
            setGeneralStats(formattedGeneralStats);
        }, (error)=>{
            console.log(error);
        })
    },[]);

    const onClearResponses = (event) => {
        event.preventDefault();
        setShowClearResponsesModal(true);
    };

    const clearResponses = () => {
        setResponsesAreBeingDeleted(true);
        SurveysService.deleteAnswersForSurvey(props.match.params.surveyId, () => {
            setResponsesAreBeingDeleted(false);
            setShowClearResponsesModal(false);
            window.location.reload();
        }, (err) => {
            console.log(err)
            setResponsesAreBeingDeleted(false);
            setShowClearResponsesModal(false);
        });
    }

    function updateQuestionChartInfoAtIndex(questionIndex, newChartInfo) {
        let newQuestionChartsInfo = questionChartsInfoRef.current;
        newQuestionChartsInfo[questionIndex] = newChartInfo;
        questionChartsInfoRef.current = newQuestionChartsInfo;

        let filledChartsInfo = newQuestionChartsInfo.filter((item) => {return typeof item !== "undefined"});
        let questionsReady = (filledChartsInfo.length > 0 && numChartsRef.current > 0 && filledChartsInfo.length === numChartsRef.current);
        setQuestionsInfoState({...questionsInfoState, questionChartsInfo: newQuestionChartsInfo, questionsReady: questionsReady});
    }

    const getFormattedGeneralStats = (generalStatsData) => {
        const totalAnswers = generalStatsData.totalAnswers ? generalStatsData.totalAnswers : 0;
		const abandons = generalStatsData.abandons ? generalStatsData.abandons : 0;
		const totalAttempts = totalAnswers + abandons;
        const numberOfMinutes = generalStatsData.averageTime ? Math.floor(generalStatsData.averageTime / 60) : 0;
        const numberOfSeconds = generalStatsData.averageTime ? Math.floor(generalStatsData.averageTime % 60) : 0;
        const minutesString = numberOfMinutes > 9 ? numberOfMinutes + "" : "0" + numberOfMinutes;
        const secondsString = numberOfSeconds > 9 ? numberOfSeconds + "" : "0" + numberOfSeconds;
        const averageTimeOfComp = minutesString + ":" + secondsString;

        let abandonRate = totalAttempts === 0 ? 0 : Math.round(abandons * 100 / totalAttempts);
        abandonRate += "%";
        return {totalAnswers, averageTimeOfComp, abandonRate};
    }

    function buildCharts(questions){
        let charts = [];
        let multiple = [];
        let chartIndex = 0;
        let numChartsToCreate = 0;
        for(const question of questions){
            const questionData = {question: question, surveyId: props.match.params.surveyId};
            if(questionTypes.includes(question.type)) {
                charts.push(
                    <ChartReportBoxComponent
                        key={"report_chart_box_" + questionData.question.id}
                        questionData={questionData}
                        divParentRef={divParentRef}
                        chartIndex={chartIndex}
                        updateChartInfo={updateQuestionChartInfoAtIndex}
                    />);
                if(question.type.localeCompare("multipleChoice") === 0) multiple.push(questionData.question.id);
                if(question.type.localeCompare("multipleOpen") === 0) {
                    chartIndex += questionData.question.selects.length;
                    numChartsToCreate += questionData.question.selects.length;
                }
                else {
                    chartIndex ++;
                    numChartsToCreate ++;
                }
            }
        }
        numChartsRef.current = numChartsToCreate;
        setReportState({ questionCharts : charts, multipleQuestions: multiple });
    }

    function getChartsPayloadPromise() {
        let chartsPayloadPromise = createChartsPayloadPromise(parseInt(props.match.params.surveyId), surveyName, generalStats, questionsInfoState.questionChartsInfo);
        return chartsPayloadPromise;
    }

    function scrollToBottom(){
        window.scrollTo(0,document.body.scrollHeight);
    }

    return (
        <React.Fragment>
            <ErrorBoundary boundaryName="Survey Report Component">
                <SurveyExportButtons surveyId={props.match.params.surveyId} multipleQuestions={reportState.multipleQuestions}
                                     createChartsPayloadPromise={getChartsPayloadPromise} questionsReady={questionsInfoState.questionsReady}
                                     isMobile={isMobile}
                />
                <div id="reports_page_content_div_id" ref={divParentRef} className="questionaire__reports">
                    <h1 className="questionaire__reports__title pb-md pt-xl">{surveyName} Report</h1>
                    <div className="quest_delete_answers__button">
                        <a href="#" className="questionaire__test__action " onClick={onClearResponses}>
                            <img src="/assets/img/builder/action_delete-dark2.png" alt=""/>
                            CLEAR RESPONSES
                        </a>
                    </div>
                    <ClearResponsesModal clearResponses={clearResponses}
                                         showModal={showClearResponsesModal}
                                         closeModal={() => {setShowClearResponsesModal(false)}}
                                         responsesAreBeingDeleted={responsesAreBeingDeleted} />
                    <div>{typeof generalStats !== "undefined" ? GeneralStatsComponent(generalStats) : ""}</div>
                    <div className="mobile--only">
                        <a onClick={() => scrollToBottom()} className="cta--normal cta--green cta--notransform">Export options</a>
                    </div>
                    <React.Fragment>
                        {reportState.questionCharts}
                    </React.Fragment>
                </div>
            </ErrorBoundary>
        </React.Fragment>
    )

}

export default withHeader(SurveyReportPage);